<template>
    <section>
        <Header
        :header_page_data="headerPageData"
        ></Header>
        <section>
            <div class="container container-app">
                <div class="row">
                    <div class="col-12 mt-5 text-center">
                        <img style="width: 330px;" src="./../../assets/offline_image.svg" alt="offline" />
                    </div>
                    <div class="col-12 text-center">
                        <span class="notfound-label">{{ $t('offline.page.offline_page_text') }}</span>
                    </div>
                    <div class="col-4 mt-3">
                    </div>
                    <div class="mt-3 col-4">
                    </div>
                    <div class="col-4 mt-3">
                    </div>
                </div>
            </div>
        </section>
    </section>
</template>
<script>
    import Header from "../layouts/Header";
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "Offline",
        components: {Header},
        mixins: [HelperMixin],
        created() {
            if (this.$route.name == 'offline-profile') {
                this.headerPageData.title = this.$t('profile.title');
                this.headerPageData.settings.show = false;
            } else if (this.$route.name == 'campaign-settings-offline') {
                this.headerPageData.title = this.$store.getters["currentCampaign"].name;
                this.headerPageData.settings.campaign = this.$store.getters["currentCampaign"];
                this.headerPageData.settings.show = true;
            }
        },
        data() {
            return {
                headerPageData: {
                    title: '',
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: false,
                    },
                    home: {
                        show: true,
                    },
                    profile: {
                        show: false
                    }
                },
            }
        }
    }
</script>